import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { BaseModel } from "../../infrastructure/model/base/BaseModel";

interface AppGlobalContextType {
  listUoM: BaseModel[];
  updateListUoM: (data: BaseModel[]) => void;

}

const AppGlobalContext = createContext<AppGlobalContextType | undefined>(undefined);

export const AppGlobalProvider = ({ children }: { children: ReactNode }) => {
  const [listUoM, setListUoM] = useState<BaseModel[]>([]);

  const updateListUoM = (data: BaseModel[]) => {
    setListUoM(data);
  };


  return (
    <AppGlobalContext.Provider
      value={{
        listUoM,
        updateListUoM,
      }}
    >
      {children}
    </AppGlobalContext.Provider>
  );
};

export const useGlobalState = (): AppGlobalContextType => {
  const context = useContext(AppGlobalContext);
  if (!context) {
    console.error("use global context must be used within an AuthProvider");
    return {} as AppGlobalContextType;
  }
  return context;
};
